import React from "react";
import { get } from "lodash";
import SideBarContent from "../SideBarContent";

const SidebarApp = (props) => {
  const { children, state } = props;
  return (
    <div className={`sidebar-container`}>
      <div className={`sidebar`} style={{ backgroundColor: "#ffffff" }}>
        <SideBarContent
          selectedMenu={get(state, "selectedMenu")}
          role={get(state, "userRole")}
        />
      </div>
      <div className="sidebar-app">{children}</div>
    </div>
  );
};
export default SidebarApp;
